import React from 'react';

type PropTypes = {
  vertical?: string;
};

const Space: React.FC<PropTypes> = ({ vertical = '0' }) => <div style={{ marginTop: vertical }} />;

export default Space;
